import { render, staticRenderFns } from "./a6.vue?vue&type=template&id=7122678a&scoped=true&"
import script from "./a6.vue?vue&type=script&lang=js&"
export * from "./a6.vue?vue&type=script&lang=js&"
import style0 from "./a6.vue?vue&type=style&index=0&id=7122678a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7122678a",
  null
  
)

export default component.exports